//  Azure AD authentication configuration and related functions.
import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: process.env.REACT_APP_REDIRECTURI
  }, 
  cache: {
    cacheLocation: 'sessionStorage', // Use 'localStorage' or 'sessionStorage'
    storeAuthStateInCookie: false,
  },
};

const pca = new PublicClientApplication(msalConfig);

await pca.initialize();

export default pca ;
